export class WebConfigFuncionalidadeRotinaResponse {
    idConfigFuncRotina: number;
    idPerfil: number;
    idPlano: number;
    idFuncionalidade: number;
    mensagem: string;
    icAtivo: string;
    dtInicio: Date;
    dtFim: Date;
    icRetidoEsteira:string;
    icPopup: string;
    mensagemPopup:string;
    nmPerfil: string;
    nmFuncionalidade:string;
    nmPlano:string;

}